export interface SelectInterface {
  label?: string;
  size?: any;
  name?: string;
  id?: string;
  defaultValue?: string | number;
  classes?: string;
}

export interface ISelectOption {
  key: string | number | undefined;
  value: string;
  disabled?: boolean;
}

export interface seriesListState {
  seriesList: [];
}

export interface modelListState {
  modelList: [];
}

export interface ruleListState {
  ruleList: IRule[];
}

export interface lookupsState {
  lookupsData: any;
}

export interface orderDetailsState {
  orderDetails: any;
}

export interface IOptions {
  currentOptions?: Array<IType>;
  choices?: any;
}

export interface IType {
  id: number;
  name: String;
  order?: any;
  uiWidget: String;
  choices: Array<IChoices>;
}

export interface IChoices {
  id: number;
  layerMedia: [];
  name?: String;
  order?: any;
  preSelected: Boolean;
  selected: Boolean;
  price: number;
  title?: String;
  hexcode?: any;
  mediaUrl?: string;
}

export interface IPerspective {
  key: string;
  value: string;
}

export const perspectiveOptions: IPerspective[] = [
  { key: "Top", value: "Top" },
  { key: "Side", value: "Side" },
];

export interface IBreadCrumb {
  optionTotalPrice: number;
  modelPrice: number;
  name: string;
  priceType: string;
  modelYear: string;
  msrp: number;
}

export interface IRule {
  id: number;
  revisionId: number;
  conditions: IRuleCondition[];
  actions: IRuleAction[];
}

export interface IRuleCondition {
  id: number;
  importKey: string;
  revisionChoiceId: number;
  isSelected: boolean;
}

export interface IRuleAction {
  id: number;
  importKey: string;
  revisionChoiceId: number;
  isSelected: boolean;
  isDisabled: boolean;
  isVisible: boolean;
}

export interface ILookups {}
